import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Headers, Items, ShippingAddress } from '../CommonRevolveOrderInfoWidget/CommonRevolveOrderInfoWidget';
import { ORDER_CANCEL_VALID_STATUSES } from '../../../../../constants/revolve';
import { useSelector } from 'react-redux';
import * as toolSelectors from '../../../../../selectors/tools';
import { Spreadsheet, SubTitleText, SubTitleTextLight } from '../../DTInfoWidget.styles';

const DTRevolveCancelOrderInfoWidget = () => {
  const selectedLineItems = useSelector(toolSelectors.getSelectedLineItems) || [];
  const lineItemsOfSelectedOrder = useSelector(toolSelectors.getLineItemsOfSelectedOrder);
  const selectedOrder = useSelector(toolSelectors.getSelectedOrder);
  const shippingAddress = selectedOrder.shippingAddress || {};
  const orderNumber = selectedOrder.id; // TODO check with @Jack if its valid, looks like we should rather get mapped value

  const revolveCancelOrderInfoWidgetData = isEmpty(selectedLineItems) ? lineItemsOfSelectedOrder : selectedLineItems;
  const { validOrderInfoData, invalidOrderInfoData } = revolveCancelOrderInfoWidgetData.reduce(
    (acc, item) => {
      if (ORDER_CANCEL_VALID_STATUSES.includes(item.status)) {
        acc.validOrderInfoData.push(item);
      } else {
        acc.invalidOrderInfoData.push(item);
      }

      return acc;
    },
    { validOrderInfoData: [], invalidOrderInfoData: [] }
  );

  return (
    <>
      {!isEmpty(validOrderInfoData) && (
        <Spreadsheet className="fs-block">
          <SubTitleText>ORDER NUMBER - {orderNumber}</SubTitleText>
          <SubTitleTextLight>VALID ITEMS</SubTitleTextLight>
          {!isEmpty(shippingAddress) && <ShippingAddress shippingAddress={shippingAddress} />}
          <Headers />
          <Items revolveOrderInfoWidgetData={validOrderInfoData} />
        </Spreadsheet>
      )}
      {!isEmpty(invalidOrderInfoData) && (
        <Spreadsheet className="fs-block">
          <SubTitleText>ORDER NUMBER - {orderNumber}</SubTitleText>
          <SubTitleTextLight>INVALID ITEMS</SubTitleTextLight>
          {!isEmpty(shippingAddress) && <ShippingAddress shippingAddress={shippingAddress} />}
          <Headers />
          <Items revolveOrderInfoWidgetData={invalidOrderInfoData} />
        </Spreadsheet>
      )}
    </>
  );
};

export default DTRevolveCancelOrderInfoWidget;
